export default __webpack_public_path__ + "static/live-like-a-local-1-337b97ad6abbf3b741995ee956127e15.png";